import { configureStore, combineReducers } from "@reduxjs/toolkit";
import userReducer from '../features/userSlice';
import userDetailReducer from '../features/userDetailSlice';
import {
    persistReducer, persistStore,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER } from 'redux-persist';
import localStorage from "redux-persist/es/storage";
import bulkCallsReducer from '../features/bulkCallsSlice';

const persistConfig = {
    key: 'root',
    storage: localStorage,
    blacklist: ['bulkCallsForLeadGen'],
}

const rootReducer = combineReducers({
    user: userReducer,
    userDetail: userDetailReducer,
    bulkCallsForLeadGen: bulkCallsReducer,
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        })
})

export const persistor = persistStore(store);